import { empty, ObservableInput, ObservedValueOf, OperatorFunction, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

export function catchErrorAndRethrow<T, O extends ObservableInput<any>>(
  errorHandler: (err: any) => void
): OperatorFunction<T, T | ObservedValueOf<O>> {
  return catchError((err) => {
    errorHandler(err);
    return throwError(err);
  });
}

export function catchErrorAndThrowEmpty<T, O extends ObservableInput<any>>(
  errorHandler: (err: any) => void
): OperatorFunction<T, T | ObservedValueOf<O>> {
  return catchError((err) => {
    errorHandler(err);
    return empty();
  });
}
